module.exports = __webpack_public_path__ + "static/media/gusset-box-render.f18e1d83.png";